import {
  getFieldWithDefault,
  Opportunity,
  OpportunityCategory,
  OpportunityFieldGenerationResponse
} from "@/opportunity/opportunity";
import { DefaultValueWarning } from "@/opportunity/opportunity_detail_page/DefaultValueWarning";
import ConditionalStaffOnly from "@/opportunity/opportunity_detail_page/ConditionalStaffOnly";
import { Button } from "@/components/ui/button";
import React, { useState } from "react";
import { UpdateFieldDialog } from "@/opportunity/opportunity_detail_page/UpdateFieldDialog";
import { UseMutationResult } from "@tanstack/react-query";

export const OpportunityEditableField = (
  {
    header,
    opportunity,
    opportunityKey,
    defaultOpportunityCategoryKey,
    noValueMessage = "No value available",
    generateValueMutation,
    showStaffView = true, // Default to true for backward compatibility
  }: {
    header: string,
    opportunity: Opportunity,
    opportunityKey: keyof Opportunity,
    defaultOpportunityCategoryKey?: keyof OpportunityCategory,
    noValueMessage?: string;
    generateValueMutation?: UseMutationResult<OpportunityFieldGenerationResponse, Error, void, unknown>,
    showStaffView?: boolean;
  }
) => {

  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);

  return (
    <div className="flex flex-row justify-between">
      <div className="flex flex-col gap-2">
        <h4 className="text-base font-semibold text-gray-800">
          {header}
        </h4>
        <div className="text-sm text-gray-600">
          <div
            dangerouslySetInnerHTML={{
              __html: getFieldWithDefault(opportunity, opportunityKey, defaultOpportunityCategoryKey, noValueMessage),
            }}
          />
        </div>
        {
          defaultOpportunityCategoryKey && (
            <DefaultValueWarning
              opportunity={opportunity}
              opportunityKey={opportunityKey}
              openEditDialog={() => setIsEditDialogOpen(true)}
              showStaffView={showStaffView}
            />
          )
        }
      </div>
      <ConditionalStaffOnly showStaffView={showStaffView}>
        <Button variant="outline" size="sm" onClick={() => setIsEditDialogOpen(true)}>
          Edit
        </Button>
      </ConditionalStaffOnly>
      <UpdateFieldDialog
        opportunity={opportunity}
        opportunityKey={opportunityKey}
        isOpen={isEditDialogOpen}
        setIsOpen={setIsEditDialogOpen}
        generateValueMutation={generateValueMutation}
      />
    </div>
  )
}
